import { combineEpics } from 'redux-observable';
import { getDocumentUploadPresignedURLEpic } from '../actions/GetDocumentUploadPresignedURL';
import { putFileInS3Epic } from '../actions/PutFileInS3';
import { uploadFileToS3Epic } from '../actions/UploadFileToS3';

export default combineEpics(getDocumentUploadPresignedURLEpic, putFileInS3Epic, uploadFileToS3Epic);
